import { CrossIcon, SearchIcon } from '../../../assets/icons';

interface SearchBarProps {
    onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
    value?: string;
    onClear?: () => void;
    onSearch?: () => void;
    disabled?: boolean;
    fromFilter?: boolean;
    width?: number;
}

const SearchBar = ({
    onChange,
    value,
    onClear,
    onSearch,
    disabled,
    fromFilter,
    width,
}: SearchBarProps) => (
    <div
        className={`flex border flex-row items-center rounded-lg p-2 focus-within:border-gray-300 focus-within:border-[1.5px] bg-bgGray h-[40px] 
    ${width ? `w-[${width}px]` : "w-full"}
    `}>
        <input
            disabled={disabled}
            onChange={onChange}
            value={value}
            className={`border-none bg-transparent outline-none resize-none w-full text-darkGray text-sm`}
            placeholder="Search"
            type="text"
            onKeyDown={(event: any) => {
                if (event.key === "Enter" && event.target.value !== "") {
                    onSearch && onSearch();
                }
            }}
        />
        {!fromFilter && (
            <>
                <div className="ms-2 cursor-pointer" onClick={() => {
                    if (onSearch && !!value) {
                        onSearch();
                    }
                }}>
                    <SearchIcon className="h-[20px] w-[20px] !text-gray-500" />
                </div>
                <div onClick={onClear} className="ms-2 cursor-pointer">
                    {value && <CrossIcon className="h-[20px] w-[20px] !text-gray-500" />}
                </div>
            </>
        )}
    </div>
);

export default SearchBar;
